const hasAssignedLocation = (assignments, locationId, brandId) => Object.values(assignments)
    .some(assignment => (assignment.ownerId === locationId || locationId === brandId) && assignment.enabled);

export default hasAssignedLocation;
